import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import './App.css'; // Importing CSS for styling
import CameraApp from './components/CameraApp'; // Import the CameraApp component

function Home() {
  const navigate = useNavigate();

  const handleGetStartedClick = () => {
    // Navigate to the CameraApp component when the button is clicked
    navigate('/camera');
  };

  return (
    <div className="container">
      <img
        src="/assets/images/chromatic-logo-coloured-1.png" // Adjust path as needed
        alt="Chromatic Logo"
        className="logo"
      />
      <h1 className="welcomeText">Welcome to Chromatic</h1>
      <p className="description">
        This app helps people with color blindness distinguish red, green, and blue colors using AI-powered camera technology.
      </p>

      <button className="button" onClick={handleGetStartedClick}>
        Get Started
      </button>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Home Route */}
        <Route path="/" element={<Home />} />
        
        {/* CameraApp Route */}
        <Route path="/camera" element={<CameraApp />} />
      </Routes>
    </Router>
  );
}

export default App;
